var $hero_slider = $('.hero-slider');
if ($hero_slider.children().length > 1) {
  $('.hero-slider')
    .slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      autoplay: false,
      autoplaySpeed: 7000,
      dots: true,
      fade: false,
      infinite: true,
      pauseOnDotsHover: true,
      pauseOnHover: false,
      speed: 1200,
    });
}

var $hero_slider_for = $('.hero-slider-for');
if ($hero_slider_for.children().length > 1) {
  $('.hero-slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.hero-slider-nav'
  });
  $('.hero-slider-nav').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: false,
    autoplaySpeed: 7000,
    asNavFor: '.hero-slider-for',
    dots: true,
    fade: false,
    infinite: true,
    pauseOnDotsHover: true,
    pauseOnHover: false,
    speed: 1200,
  });
}

// picture-tag images to background images
$(window).on('load resize orientationchange', function() {
  $('.pt-trigger picture').each(function() {
    var getImageSrc;
    if ($(window).width() < 420) {
      getImageSrc = $('img', this).attr('src');
    } else if ($(window).width() < 768) {
      getImageSrc = $('.tablet', this).attr('srcset');
    } else {
      getImageSrc = $('.desktop', this).attr('srcset');
    }
    $(this).parents('.pt-trigger').css('background-image', 'url(' + getImageSrc + ')');
  });
});

// parallax effect for hero images
$(window).on('scroll', function() {
  var scrollTop = $(window).scrollTop();
  var height = 44;
  var imgPos = scrollTop / 2 - height + 'px';
  var reset = '0px';
  if (scrollTop >= 88) {
    $('.hero').find('.pt-trigger').css('transform', 'translateY(' + imgPos + ')');
  } else if (scrollTop < 88) {
    $('.hero').find('.pt-trigger').css('transform', 'translateY(' + reset + ')');
  }
});